import { AbstractSceneTransition } from "slotworks/graphics/layers/scene-transitions/abstract-scene-transition"
import Contract from "slotworks/utils/contract";
import Layers from "slotworks/graphics/layers/layers";
import { FadeIn, FadeOut, Zoom } from "slotworks/graphics/animation/base-animations";
import * as TweenJS from "slotworks/utils/tween";
import Point from "slotworks/utils/geom/point";
import Logger = require("js-logger");
import { parallel } from "slotworks/utils/race-utils";
import { CenterPivot, PIXIElement } from "slotworks/graphics/pixi/group";
import deviceInfo from "slotworks/utils/device-info";
import canvasManager from "slotworks/graphics/canvas/canvas-manager";

export default class BonusWheel3Transitions extends AbstractSceneTransition {

    private glowContainer: PIXIElement;
    private glowTweens: TweenJS.Tween[] = [];

    // glowstack_1 ... glowstack_5
    public in(): Contract<void> {
        return new Contract((resolve) => {
            CenterPivot(Layers.CelebrationBackground.getSprite("winrect")).scale.set(3, 3);
            parallel([
                () => FadeIn(Layers.CelebrationBackground.getSprite("winrect"), 160),
                () => this.zoomInStacks(),
                () => Zoom(Layers.Prompts.container, 0, 1.15, 250, 0, TweenJS.Easing.Linear.None, 0, new Point(0.5, 0.4)),
            ])
                .then(() => {
                    deviceInfo.onLayoutChange.add(this.onLayoutChange);
                    new TweenJS.Tween(Layers.Prompts.container.scale)
                        .to({ x: 1, y: 1 }, 60)
                        .onComplete(() => { resolve(null) })
                        .start();
                });
        });
    }

    public out(): Contract<void> {
        return new Contract((resolve) => {
            deviceInfo.onLayoutChange.remove(this.onLayoutChange);
            this.stopTweens();
            parallel([
                () => Zoom(Layers.Prompts.container, 1, 0, 250, 0, TweenJS.Easing.Linear.None, 0, new Point(0.5, 0.5)),
                () => this.zoomOutStacks(),
                () => FadeOut(Layers.CelebrationBackground.getSprite("winrect"), 250)
            ]).then(() => resolve(null));
        });
    }

    private zoomOutStacks() {
        return new Contract(resolve => {
            new TweenJS.Tween(this.glowContainer.scale)
                .to({ x: 0, y: 0 }, 200)
                .onComplete(() => {
                    resolve(null);
                }).start();
        });
    }

    private zoomInStacks() {
        return new Contract(resolve => {
            const glowstack = [];
            this.glowTweens = [];
            for (let i = 5; i >= 1; i--) {
                const sprite = Layers.CelebrationBackground.getSprite("glowstack_" + i);
                glowstack.push(sprite);
            }
            this.glowContainer = CenterPivot(glowstack as PIXIElement[]);
            for (let i = 0; i < glowstack.length; i++) {
                this.glowTweens.push(
                    new TweenJS.Tween(CenterPivot(glowstack[i]))
                        .to({ rotation: Math.PI * 2 }, (30000 + i * 10000) * (i % 2 ? 1 : -1))
                        .repeat(Infinity)
                        .start());

            }
            this.glowContainer.scale.set(0, 0)
            new TweenJS.Tween(this.glowContainer.scale)
                .to({ x: 1, y: 1 }, 200)
                .onComplete(() => {
                    resolve(null);
                }).start();
        });
    }

    private onLayoutChange = () => {
        setTimeout(() => {
            const point = Layers.CelebrationBackground.globalToLocal(new Point(canvasManager.stageWidth / 2, canvasManager.stageHeight / 2));
            this.glowContainer.position.set(point.x, point.y);
        }, 1);
    }

    private stopTweens() {
        for (let tween of this.glowTweens) {
            tween.stop();
            TweenJS.remove(tween);
        }
        this.glowTweens = [];
    }

}